import styled, { keyframes } from 'styled-components'
import theme from '../../theme'

export const MapWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .qu-map {
    height: 100%;
    width: 100%;
  }
`

/**
 * The pin is a fixed DOM overlay anchored so its tip sits exactly at the map
 * centre. The map moves under it (drag / zoom), so the reported coordinate is
 * simply the map centre — no projection maths required. This keeps the map
 * provider swappable: only `PinMap` knows about the underlying map library.
 */
export const PinWrapper = styled.div<{ dragging: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  z-index: 400;
  transform: translate(-50%, -100%)
    translateY(${(props) => (props.dragging ? '-8px' : '0')});
  transition: transform 0.2s ease;
`

export const PinHead = styled.div`
  position: absolute;
  left: -23px;
  top: -46px;
  width: 46px;
  height: 46px;
  background-color: ${theme.cornFlower500};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);

  svg {
    width: 22px;
    height: 22px;
  }

  svg path {
    fill: #ffffff;
  }
`

export const PinStem = styled.div`
  position: absolute;
  left: -2px;
  top: -8px;
  width: 4px;
  height: 10px;
  background-color: ${theme.cornFlower500};
`

const pulse = keyframes`
  0% { transform: translate(-50%, -50%) scale(0.6); opacity: 0.9; }
  100% { transform: translate(-50%, -50%) scale(2.2); opacity: 0; }
`

/** Small dot + pulse marking the precise point the pin is reporting. */
export const PinTarget = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  pointer-events: none;
  z-index: 399;
  transform: translate(-50%, -50%);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: ${theme.cornFlower500};
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
    transform: translate(-50%, -50%);
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: ${theme.cornFlower500};
    animation: ${pulse} 1.8s ease-out infinite;
  }
`
